import React, { useState } from "react";
import {
    createTheme,
    IconButton,
    Modal,
    TextField,
    ThemeProvider,
    Button,
} from "@material-ui/core";
import styles from "./EditCaption.module.css";
import EditIcon from "@material-ui/icons/Edit";
import { useDispatch, useSelector } from "react-redux";
import { EditVideoCaption } from "../../../store/actions/ExVideoActions";
import { AppState } from "../../../root/RootReducer";

interface EditCaptionProps {
    captionId: number;
    beforeEditText: string;
    setEditModalOpen: (target: boolean) => void;
    setIsCaptionEditing: (target: boolean) => void;
}

const theme = createTheme({
    palette: {
        secondary: {
            main: "#16ADC1",
        },
    },
});

export default function EditCaption({
    captionId,
    beforeEditText,
    setEditModalOpen,
    setIsCaptionEditing,
}: EditCaptionProps) {
    const dispatch = useDispatch();
    const { user } = useSelector((state: AppState) => ({
        user: state.user.user,
    }));

    // STT編集モーダル表示制御
    const [isOpenEditCaptionModal, ShowEditCaptionModal] = useState(false);
    const [isErrorInputCaption, ErrorInputCaption] = useState(false);
    const [inputCaption, InputCaption] = useState(beforeEditText);
    const [isUserInput, ChangeUserInputFlag] = useState(false);

    const OpenEditCaptionModal = () => {
        ShowEditCaptionModal(true);
        setIsCaptionEditing(true);
        setEditModalOpen(true);
    };

    const CloseEditCaptionModal = () => {
        ShowEditCaptionModal(false);
        setIsCaptionEditing(false);
        setEditModalOpen(false);
        ErrorInputCaption(false);
        ChangeUserInputFlag(false);
        InputCaption("");
    };

    const InputEditCaption = (event: any) => {
        ChangeUserInputFlag(true);
        InputCaption(event.target.value);
    };

    const DoneEditInputCaption = () => {
        if (inputCaption !== "" && user) {
            CloseEditCaptionModal();
            dispatch(
                EditVideoCaption({
                    captionId: captionId,
                    userId: user.id,
                    beforeUpdateTranscript: beforeEditText,
                    afterUpdateTranscript: inputCaption,
                })
            );
        } else {
            ErrorInputCaption(true);
        }
    };

    return (
        <div>
            <IconButton onClick={OpenEditCaptionModal} className={styles.captionEditIcon}>
                <EditIcon
                    style={{ width: "20px", height: "20px", color: "var(--button-bg)" }}
                    color="secondary"
                />
            </IconButton>

            {/* STT編集モーダル */}
            <Modal open={isOpenEditCaptionModal} onClose={CloseEditCaptionModal}>
                <div className={styles.captionEditModal}>
                    <div style={{ display: "flex" }}>
                        <div className={styles.modalLeft}>
                            <TextField
                                disabled
                                autoComplete="off"
                                variant="outlined"
                                multiline
                                fullWidth
                                minRows={5}
                                value={beforeEditText}
                            />
                        </div>
                        <div className={styles.modalRight}>
                            <ThemeProvider theme={theme}>
                                <TextField
                                    color="secondary"
                                    onChange={InputEditCaption}
                                    multiline
                                    fullWidth
                                    minRows={5}
                                    autoComplete="off"
                                    variant="outlined"
                                    defaultValue={beforeEditText}
                                />
                            </ThemeProvider>
                        </div>
                    </div>
                    <div className={styles.captionEditModalButton}>
                        <div className={styles.cancelButton}>
                            <Button
                                size="small"
                                variant="outlined"
                                type="submit"
                                onClick={CloseEditCaptionModal}
                                style={{
                                    color: "var(--gray-42)",
                                    borderColor: "var(--gray-42)",
                                }}
                            >
                                キャンセル
                            </Button>
                        </div>
                        <div className={styles.updateButton}>
                            <Button
                                size="small"
                                variant="outlined"
                                type="submit"
                                onClick={DoneEditInputCaption}
                                disabled={!isUserInput}
                                style={
                                    isUserInput
                                        ? {
                                              color: "var(--gray-42)",
                                              borderColor: "var(--gray-42)",
                                          }
                                        : {
                                              color: "var(--gray-85)",
                                              borderColor: "var(--gray-85)",
                                          }
                                }
                            >
                                更新
                            </Button>
                        </div>
                    </div>
                    <div
                        className={styles.captionEditModalAlart}
                        style={{ visibility: isErrorInputCaption ? "visible" : "hidden" }}
                    >
                        ※入力してください
                    </div>
                </div>
            </Modal>
        </div>
    );
}
